import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  align?: "left" | "center";
  tone?: "light" | "dark";
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "left",
  tone = "light",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`${isCenter ? "mx-auto text-center" : ""} max-w-2xl`}>
      {eyebrow && (
        <span
          className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-label tracking-wide ${
            tone === "dark"
              ? "bg-primary-500/20 text-primary-100"
              : "bg-accent-100 text-accent-800"
          }`}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-current" />
          {eyebrow}
        </span>
      )}
      <h2
        className={`mt-4 font-heading text-2xl md:text-3xl lg:text-4xl font-bold leading-snug ${
          tone === "dark" ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-4 text-sm md:text-base leading-relaxed ${
            tone === "dark" ? "text-background-200" : "text-foreground-600"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}